import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehouseCCCCommoditiesAdapter = getAdapter();

const warehouseCCCCommoditiesSlice = createSlice({
  name: 'warehouseCCCCommodities',
  initialState: warehouseCCCCommoditiesAdapter.getInitialState(),
  reducers: {
    setWarehouseCCCCommodities: (state, { payload: { cccCommodities } }) => {
      warehouseCCCCommoditiesAdapter.setAll(state, cccCommodities);
    },
  },
});

const selectors = warehouseCCCCommoditiesAdapter.getSelectors(({ warehouseCCCCommodities }) => warehouseCCCCommodities);

export const getWarehouseCCCCommoditiesIncludingDeleted = (state) => selectors.selectAll(state);

export const getWarehouseCCCCommodities = (state) => getWarehouseCCCCommoditiesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setWarehouseCCCCommodities,
} = warehouseCCCCommoditiesSlice.actions;

export default warehouseCCCCommoditiesSlice.reducer;
